<script setup lang="ts">
import LazyImage from "@/components/LazyImage.vue";

defineProps<{
  src: string;
  srcPlaceholder?: string;
  alt?: string;
  width?: number;
  height?: number;
}>();
const emit = defineEmits(["load"]);
</script>

<template>
  <LazyImage
    :src="src"
    :src-placeholder="srcPlaceholder"
    :alt="alt"
    :width="width"
    :height="height"
    @load="emit('load', $event)"
  ></LazyImage>
</template>

<style scoped>
.v-lazy-image {
  opacity: 0;
  transition: opacity 2s;
}

.v-lazy-image-loaded {
  opacity: 1;
}
</style>
